// Lines of this category are browsed by milling group; every other line is browsed by material,
// which means its surface is picked in the catalog instead of in the configurator.
export const WHITE_DOOR_CATEGORY = 'Weißlacktüren';

export const SERIALIZATION_VERSION = 7;
export const SHARE_LINK_VERSION_PARAM = 'v';
export const SHARE_LINK_DATA_PARAM = 'link';
